import { DialogContext } from '@/contexts/DialogContext';
import { SnackbarContext } from '@/contexts/SnackbarContext';
import { BottomSheetIframeContext } from '@/contexts/BottomSheetIframeContext';
import { BottomSheetContext } from '@/contexts/BottomSheetContext';
import { ProfileCardModalContext } from '@/contexts/ProfileCardModalContext';
import { PhoneBillDialogContext } from '@/contexts/PhoneBillDialogContext';
import { createContextFactory } from '@/contexts/createContextFactory';

export const useDialog = () => createContextFactory(DialogContext);
export const useSnackbar = () => createContextFactory(SnackbarContext);
export const useBottomSheetIframe = () =>
  createContextFactory(BottomSheetIframeContext);
export const useBottomSheet = () => createContextFactory(BottomSheetContext);
export const useProfileCardModal = () =>
  createContextFactory(ProfileCardModalContext);
export const usePhoneBillDialog = () =>
  createContextFactory(PhoneBillDialogContext);
